__turbopack_context__.v({
  "main-header": "main-header-module-scss-module__yiLOFa__main-header",
});
